<div
  class="max-w-screen-xl mx-auto bg-white dark:bg-gray-800 shadow rounded-lg px-4 py-6 mt-4 h-[90vh] w-full overflow-auto"
  [ngClass]="{ 'overflow-hidden': modalSelectProvider || showAddressModal }">
  <div class="flex justify-start">
    <span
      class="material-icons-outlined text-[24px] text-yellow-500 group-hover:text-white transition-colors pr-2 pt-1">person_add</span>
    <h2 class="text-xl font-semibold mb-4 my-theme-color-text dark:text-yellow-500">รายการสมาชิก</h2>
  </div>
  <!-- เนื้อหาอื่น เช่น input / table -->
  <!-- ตาราง + scroll แนวนอนเฉพาะภายใน -->
  <!-- ค้นหา -->



  <div class=" flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
    <!-- input search -->
    <input type="text" [(ngModel)]="search" placeholder="ค้นหาชื่อ, เบอร์โทร หรือป้ายทะเบียน"
      class="bg-white dark:bg-gray-700 w-full md:w-1/2 border border-gray-300 dark:border-gray-600 rounded px-4 py-2 focus:outline-none focus:ring my-theme-color-input dark:text-gray-300 rounded-xl" />

    <!-- dropdown แสดงจำนวน -->
    <div class="flex items-center gap-2">
      <label for="pageSize" class="text-sm text-gray-600">แสดง:</label>
      <select [(ngModel)]="pageSize" id="pageSize"
        class="text-sm border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 my-theme-color-input">
        <option *ngFor="let size of pageSizeOptions" [value]="size">
          {{ size }}
        </option>
      </select>
    </div>
  </div>

  <!-- ตาราง -->
  <div class="w-full overflow-x-auto rounded-xl">
    <p class="text-xs text-gray-400 mt-1 md:hidden">
      👈👉 เลื่อนซ้าย-ขวาเพื่อดูข้อมูลเพิ่มเติม
    </p>
    <div class="flex flex-col overflow-x-auto p-4">
      <table class="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-xl">
        <thead class="bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300">
          <tr>
            <th class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider rounded-tl-lg">
              ลำดับ
            </th>
            <th class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              ชื่อ
            </th>
            <th class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              LINE NAME
            </th>
            <th class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              เบอร์โทรศัพท์
            </th>
            <th class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              วันที่สมัคร
            </th>
            <th
              class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider rounded-tr-lg text-center">
              จัดการ
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let member of pagedMembers; let i = index"
            class="cursor-pointer bg-white dark:bg-gray-800 hover:bg-yellow-50 dark:hover:bg-gray-700 transition border-b border-gray-200 dark:border-gray-700">
            <td class="text-center">
              {{ (page - 1) * pageSize + i + 1 }}
            </td>
            <td class="px-6 py-3 whitespace-nowrap text-gray-500 dark:text-gray-300">
              {{ member.name }}
            </td>
            <td class="px-6 py-3 whitespace-nowrap text-gray-500 dark:text-gray-300">
              {{ member.fullName }}
            </td>
            <td class="px-6 py-3 whitespace-nowrap text-gray-500 dark:text-gray-300">
              {{ member.phone }}
            </td>
            <td class="px-6 py-3 whitespace-nowrap text-gray-500 dark:text-gray-300">
              {{ member.createDate }}
            </td>
            <td class="px-6 py-3 whitespace-nowrap text-gray-500 dark:text-gray-300 text-center">
              <!-- ปุ่มสมัครสมาชิก -->
              <button
                class="text-white px-3 py-2 rounded-lg text-sm mr-2 text-white bg-green-400 hover:bg-green-500 hover:text-white hover:border-green-400 disabled:cursor-not-allowed"
                (click)="register(member)">
                สมัคร
              </button>

              <!-- ปุ่มต่ออายุ -->
              <button
                class="text-white px-3 py-2 rounded-lg text-sm mr-2 text-white bg-red-500 hover:bg-red-600 hover:text-white hover:border-red-500 disabled:cursor-not-allowed"
                (click)="renew(member)">
                ต่ออายุ
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Pagination -->
  <div class="flex flex-col sm:flex-row justify-between items-center mt-6 gap-4">
    <span class="text-xs text-gray-500 dark:text-gray-400">
      หน้า {{ page }} / {{ totalPages }}
    </span>

    <div class="flex gap-2">
      <button
        class="px-4 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md text-gray-600 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="page = page - 1" [disabled]="page <= 1">
        ก่อนหน้า
      </button>

      <button
        class="px-4 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md text-gray-600 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="page = page + 1" [disabled]="page >= totalPages">
        ถัดไป
      </button>
    </div>
  </div>
</div>

<!-- Modal Select Providers -->
<div *ngIf="modalSelectProvider"
  class="fixed inset-0 z-20 flex items-start top-0 justify-center bg-black bg-opacity-60 pt-10">
  <div class="bg-white dark:bg-gray-800 w-full max-w-xl p-6 rounded-lg shadow-lg relative overflow-y-auto max-h-[90vh]">
    <!-- ปุ่มปิด -->
    <button (click)="modalSelectProvider = false"
      class="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-4xl font-bold">
      &times;
    </button>

    <h2 class="text-xl font-semibold mb-4 dark:text-gray-200">เลือกผู้ให้บริการลานจอด</h2>

    <!-- ค้นหา -->
    <input type="text" [(ngModel)]="searchProvider" placeholder="ค้นหาชื่อผู้ให้บริการ..."
      class="w-full px-3 py-2 mb-4 border dark:border-gray-600 rounded-md focus:outline-none focus:ring focus:ring-blue-300 dark:bg-gray-700 dark:text-gray-200" />

    <!-- รายการ -->
    <ul class="max-h-64 overflow-y-auto space-y-2">
      <li *ngFor="let provider of filteredProviders()" (click)="selectProvider(provider)"
        class="p-3 bg-gray-100 dark:bg-gray-700 rounded hover:bg-blue-100 dark:hover:bg-gray-600 cursor-pointer">
        <div class="font-medium dark:text-gray-200">{{ provider.name }}</div>
        <div class="text-sm text-gray-500 dark:text-gray-400">{{ provider.address }}</div>
      </li>
    </ul>
  </div>
</div>



<!--------------------------------------------------- Modal --------------------------------------------->
<!-- Modal Select MemberCard -->
<div *ngIf="modalSelectMemberCard"
  class="fixed inset-0 z-20 flex items-start justify-center bg-black bg-opacity-60 pt-10"
  (keydown.escape)="modalSelectMemberCard = false" tabindex="0">
  <div class="bg-white dark:bg-gray-800 w-full max-w-xl p-6 rounded-lg shadow-lg relative overflow-y-auto max-h-[90vh]">
    <!-- ปุ่มปิด -->
    <button (click)="modalSelectMemberCard = false"
      class="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-4xl font-bold" aria-label="ปิดหน้าต่าง">
      &times;
    </button>

    <h2 class="text-xl font-semibold mb-4 text-center dark:text-gray-200">เลือกบัตรสมาชิก</h2>
    <!-- รายการ -->
    <div class=" relative overflow-y-auto space-y-2 " style="height: calc(100vh - 500px);">
      <ng-container *ngIf="filteredMemberCard().length > 0; else noResult" class="">
        <li *ngFor="let memberCard of filteredMemberCard()" (click)="selectMemberCard(memberCard)"
          class="p-3 bg-gray-100 dark:bg-gray-700 rounded hover:bg-blue-100 dark:hover:bg-gray-600 cursor-pointer shadow-sm transition">
          <div class="font-medium dark:text-gray-200">{{ memberCard.card_name }}</div>
          <div class="text-sm text-gray-500 dark:text-gray-400">
            {{ memberCard.plate_number }} ({{ memberCard.vehicle_type }})
          </div>
          <div class="text-sm text-gray-500 dark:text-gray-400">
            วันหมดอายุ :
            {{ memberCard.expire_date | date : "dd/MM/yyyy HH:mm" }}
          </div>
        </li>
      </ng-container>

      <!-- ไม่มีข้อมูล -->
      <ng-template #noResult>
        <div class="text-center text-gray-400 py-6">ไม่พบข้อมูลบัตรสมาชิก</div>
      </ng-template>
    </div>
  </div>
</div>




<!-- Modal Register -->
<div *ngIf="modalRegister" class="fixed inset-0 z-10 flex items-start justify-center bg-black/50 pt-20 pb-20">
  <!-- Modal Box -->
  <div
    class="bg-white dark:bg-gray-800 w-full max-w-screen-md max-h-screen p-4 sm:p-6 rounded-lg shadow-lg relative overflow-y-auto h-full">
    <div class="mb-6 border-b border-gray-200 dark:border-gray-700 flex items-center">
      <!-- หัวข้อ -->
      <h2 class="text-2xl font-semibold mb-6 dark:text-gray-200">
        {{
        renew_
        ? "แบบฟอร์มต่ออายุสมาชิกรายเดือน"
        : "แบบฟอร์มสมัครสมาชิกรายเดือน"
        }}
      </h2>
      <!-- ปุ่มปิด -->
      <button (click)="onCloseRegisterModal()" class="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-5xl">
        &times;
      </button>
    </div>

    <!-- ฟอร์มแบบ 2 คอลัมน์ -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
      <!-- ซ้าย -->
      <div>
        <!-- สถานที่ -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            สถานที่ให้บริการลานจอด
          </label>
          <div class="flex gap-2">
            <input type="text" [value]="providerName" readonly
              class="flex-1 px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300" />
            <button type="button" (click)="openLocationModal()"
              class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-red-600 whitespace-nowrap rounded-md">
              เลือก
            </button>
          </div>
        </div>

        <div *ngIf="renew_" class="mb-4">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            บัตรสมาชิกจอดรถ
          </label>
          <div class="flex gap-2">
            <input type="text" [value]="cardMemberName" readonly
              class="flex-1 px-3 py-2 text-sm border dark:border-gray-600 rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300" />
            <button type="button" (click)="openMemberCardModal()"
              class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-red-600 whitespace-nowrap rounded-md">
              เลือก
            </button>
          </div>
        </div>

        <div class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500">*</span>ประเภทการรับชำระ
          </label>
          <select [(ngModel)]="selectedFeeType" [disabled]="!disabled" (change)="handleFeeType($event)"
            class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm dark:bg-gray-700 dark:text-gray-200 disabled:opacity-50">
            <option value="" disabled selected>
              กรุณาเลือกประเภทการรับชำระ
            </option>
            <option *ngFor="let option of FeeTypeOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div *ngIf="showBank" class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500">*</span>ประเภทบัญชีธนาคาร
          </label>
          <select [(ngModel)]="selectedAccountId" (change)="handleAccount($event)"
            class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm dark:bg-gray-700 dark:text-gray-200">
            <option value="" disabled selected>กรุณาเลือกบัญชีธนาคาร</option>
            <option *ngFor="let option of BankOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="space-y-4 mb-4" *ngIf="selectedFeeType != 1">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            แนบหลักฐานเพิ่มเติม
          </label>
          <!-- Input เลือกรูป -->
          <label
            class="flex flex-col items-center justify-center w-full h-25 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 border-gray-300 dark:border-gray-600 dark:hover:bg-gray-700 transition duration-150 ease-in-out">
            <div class="flex flex-col items-center justify-center py-3">
              <svg class="w-6 h-6 mb-2 text-gray-400 dark:text-gray-300" fill="none" stroke="currentColor"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16l-4-4m0 0l4-4m-4 4h18M3 12h18"></path>
              </svg>
              <p class="mb-1 text-sm text-gray-500 dark:text-gray-400 text-center">
                <span class="font-medium">แนบรูป</span>
              </p>
              <p class="text-xs text-gray-400 dark:text-gray-500 text-center">
                รองรับ .JPG, .PNG
              </p>
            </div>

            <input type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)" />
          </label>

          <!-- แสดงรูป preview -->
          <div *ngIf="previewUrl" class="mt-4 items-center justify-center">
            <img [src]="previewUrl" alt="รูปตัวอย่าง" class="max-w-xs h-20 w-50 rounded-lg shadow" />
          </div>
        </div>

        <!-- วันที่ -->
        <div class="mb-4">
          <p class="text-red-500 text-xs mt-1" *ngIf="renew_">
            ต้องเริ่มหลังจาก : {{ expire_date | date : "dd/MM/yyyy HH:mm" }}
          </p>
          <label class="text-sm text-gray-700 dark:text-gray-300 mb-1 block">วันที่เริ่มต้นใช้งาน</label>
          <input type="date" [(ngModel)]="startDate"
            class="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full text-sm dark:bg-gray-700 dark:text-gray-200" />
        </div>

        <!-- ประเภทรถ -->
        <div class="mb-4">
          <label class="text-sm block text-gray-700 dark:text-gray-300 mb-2">
            <span class="text-sm text-red-500">*</span>ประเภทยานพาหนะ
          </label>
          <div *ngIf="isLoading" class="text-sm text-gray-500 dark:text-gray-400">
            กำลังโหลด...
          </div>
          <div class="flex flex-wrap gap-2">
            <button *ngFor="let option of CarOptions" (click)="handleSelectVehicleType(option.value)"
              [disabled]="!disabled || renew_"
              class="shadow px-4 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 disabled:opacity-50"
              [ngClass]="{
                'bg-green-400 text-white border-green-400': selectedCar === option.value,
                'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600':
                  selectedCar !== option.value
              }">
              {{ option.label }}
            </button>
          </div>
        </div>
        <!-- แพ็คเกจ -->
        <div class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2">
            <span class="text-sm text-red-500">*</span>แพ็คเกจ
          </label>
          <select [(ngModel)]="selectedOption" (ngModelChange)="handlePackChange($event)" name="selectedOption"
            class="bg-white dark:bg-gray-700 border border-gray-300 border-gray-300 dark:border-gray-600 rounded-lg w-full py-2 px-3 text-sm focus:outline-none focus:ring focus:ring-blue-300"
            [ngClass]="{
              'text-gray-400 dark:text-gray-500': selectedOption === null,
              'text-gray-700 dark:text-gray-200': selectedOption !== null
            }">
            <option [ngValue]="null" disabled>กรุณาเลือกแพ็คเกจ</option>
            <option *ngFor="let option of CardOptions" [value]="option.value" [disabled]="option.value === null">
              {{ option.label }}
            </option>
          </select>
        </div>

        <!-- ชื่อ -->
        <div class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2">
            <span class="text-sm text-red-500">*</span>ชื่อผู้สมัคร
          </label>
          <input [(ngModel)]="customer_name" name="customer_name"
            class="bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg w-full py-2 px-3 text-sm focus:outline-none focus:shadow-outline dark:text-gray-200"
            type="text" placeholder="กรุณากรอกชื่อผู้สมัคร" />
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500 text-sm">*</span>เบอร์โทรศัพท์
          </label>
          <input
            class="bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg w-full py-2 px-3 text-sm focus:outline-none focus:shadow-outline dark:text-gray-200 disabled:opacity-50"
            id="phoneNo" type="tel" [disabled]="!disabled" (input)="filterNumberOnly($event); validateForm()"
            pattern="0[0-9]{9}" maxLength="10" placeholder="0912345678" (change)="handleCheckboxChange($event)"
            [(ngModel)]="phoneNo" name="phoneNo" #phoneNoField="ngModel" />
          <p class="text-red-500 text-xs mt-1" *ngIf="
              phoneNoField.invalid &&
              (phoneNoField.dirty || phoneNoField.touched)
            ">
            กรุณากรอกเบอร์โทรให้ถูกต้อง (ขึ้นต้นด้วย 0 และมี 10 หลัก)
          </p>
        </div>
        <div class="mb-4">
          <!-- Input ทะเบียน -->
          <div class="flex-1 mt-4">
          </div>
        </div>
      </div>

      <!-- ขวา -->
      <div>
        <div class="relative">
          <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2 mt-4">
            <span class="text-red-500 text-sm">*</span> หมายเลขป้ายทะเบียน
          </label>
          <label for="codeInvite" class="block text-sm text-gray-700 dark:text-gray-400 mb-1"><span
              class="block text-xs text-red-500 mb-2 ml-1">* ถ้าแก้ไขเลขทะเบียนคือการเพิ่มใหม่</span></label>
          <div class="flex">
            <!--- Input --->
            <input type="text"
              class="w-full border border-gray-300 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 dark:text-gray-200 rounded-tl-md p-2 mt-2"
              placeholder="ค้นหาทะเบียนรถ" (input)="filterCarPlate($event)" />
            <button class="bg-green-500 text-white rounded-tr-md p-2 mt-2 transition-colors disabled:opacity-50"
              [ngClass]="{ 'opacity-50 cursor-not-allowed': renew_ || selectedCar == null }"
              (click)="openModalVehiclePlate(); $event.preventDefault()" [disabled]="renew_ || selectedCar == null">
              เพิ่ม
            </button>
          </div>
          <!--- Car Plate Checkbox --->
          <div
            class="overflow-y-scroll h-40 relative border-l border-r border-b border-gray-300 border-gray-300 dark:border-gray-600 rounded-b-md">
            <!-- *ngIf="!renew_" -->
            <div *ngIf="!renew_">
              <div *ngFor="
                  let i of carFilteredPlateList.length > 0
                    ? carFilteredPlateList
                    : carPlateList;
                  let idx = index
                " class="z-[0] flex justify-between items-center">
                <!--- Checkbox --->
                <div class="flex space-x-4 items-center px-4 py-2 w-full dark:text-gray-200"
                  (click)="toggleSelect(i, $event)" [ngClass]="{
                    'bg-yellow-100 dark:bg-yellow-900 border-yellow-500': isSelected(i.plate_number),
                    'bg-white dark:bg-gray-800': !isSelected(i.plate_number)
                  }">
                  <div class="relative flex items-center justify-center">
                    <input type="checkbox" class="appearance-none rounded-sm h-5 w-5 text-yellow-500 absolute"
                      [ngClass]="{
                                            'border border-gray-300' : !isSelected(i.plate_number),
                                        }" [checked]="isSelected(i.plate_number)" (click)="$event.stopPropagation()"
                      (change)="toggleSelect(i, $event)" />
                    <div class="absolute w-5 h-5" *ngIf="isSelected(i.plate_number)">
                      <!-- Animated checkbox tick SVG -->
                      <svg class="w-full h-full text-yellow-500" viewBox="0 0 48 48" fill="none">
                        <rect x="2" y="2" width="44" height="44" rx="8" fill="#FFFBEA" stroke="#FACC15"
                          stroke-width="4" />
                        <path d="M14 25L22 33L34 17" fill="none" stroke="#FACC15" stroke-width="4"
                          stroke-linecap="round" stroke-linejoin="round">
                          <animate attributeName="stroke-dasharray" from="0,40" to="40,0" dur="0.3s" fill="freeze" />
                          <animate attributeName="stroke-dashoffset" from="40" to="0" dur="0.3s" fill="freeze" />
                        </path>
                      </svg>
                    </div>
                  </div>
                  <label class="text-[14px]">{{ i.plate_number }}</label>
                </div>
              </div>
            </div>
            <!--- ต่ออายุ Checkbox --->
            <div *ngIf="renew_">
              <div *ngFor="
                  let i of carFilteredPlateList.length > 0
                    ? carFilteredPlateList
                    : carPlateList;
                  let idx = index
                " class="z-[0] flex justify-between items-center">
                <!--- Checkbox --->
                <div class="flex space-x-4 items-center px-4 py-2 w-full dark:text-gray-200" [ngClass]="{
                    'bg-yellow-100 dark:bg-yellow-900': isSelected(i.plate_number),
                    'bg-white dark:bg-gray-800': !isSelected(i.plate_number)
                  }">
                  <label class="text-[14px]">{{ i.plate_number }}</label>
                </div>
              </div>
            </div>
          </div>
          <div>
            <input type="file" accept=".xlsx, .xls" (change)="onExcelFileSelected($event)" style="display: none"
              #excelInput />
          </div>
        </div>

        <div class="mt-4">
          <div class="mt-4">
            <div class="flex items-center justify-between border-b border-gray-300 dark:border-gray-600 py-3 mt-4">
              <span class="text-gray-800 dark:text-gray-300 text-sm">
                ขอใบกำกับภาษีแบบเต็มรูป
              </span>
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" [(ngModel)]="isRequestTax"
                  class="w-5 h-5 text-green-600 border-gray-300 rounded checked:bg-green-500" />
              </label>
            </div>

            <div *ngIf="isRequestTax" class="w-full bg-white dark:bg-gray-700 mt-2 rounded-xl shadow-md p-1 space-y-3">
              <div
                class="flex items-center justify-between text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg px-4 py-3 transition duration-200 cursor-pointer"
                (click)="openTaxModal()">
                <div class="flex items-center gap-3">
                  <i class="fa-solid fa-receipt text-blue-500 text-sm"></i>
                  <span class="text-base">เพิ่มข้อมูลการออกใบกำกับภาษี</span>
                </div>
                <i class="fas fa-chevron-right text-gray-400"></i>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <label class="block text-gray-700 dark:text-gray-300 text-sm mt-4"> หมายเหตุ </label>
            <textarea id="description" rows="4" [(ngModel)]="remarks"
              class="bg-white dark:bg-gray-700 border border-gray-300 border-gray-300 dark:border-gray-600 rounded-lg w-full px-4 py-2 text-black dark:text-gray-200 text-sm leading-snug focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-y"
              placeholder="หมายเหตุ ..."></textarea>
          </div>
        </div>

        <!-- ปุ่มบันทึก -->
        <div class="md:col-span-2 flex justify-end gap-2 mt-4">
          <button type="button" (click)="modalRegister = false"
            class="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 dark:text-gray-500">
            ยกเลิก
          </button>
          <button type="submit" class="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            (click)="submitRequest()">
            {{ renew_ ? "ต่ออายุ" : "สมัคร" }}
          </button>
        </div>
      </div>
    </div>
  </div>




</div>


<!--------------------------------------------- Modal ------------------------------------->

<!-- ✅ Moved showAddressModal to bottom to ensure it stays on top -->
<div *ngIf="showAddressModal" class="fixed inset-0 z-20 flex items-start justify-center bg-black bg-opacity-60 pt-10">
  <div class="bg-white dark:bg-gray-800 rounded-xl p-5 w-96 shadow-lg max-h-[80vh] overflow-y-auto">
    <h2 class="text-lg font-bold mb-4 dark:text-gray-200">เลือกที่อยู่</h2>
    <div *ngFor="let item of filteredAddressList"
      class="p-3 border dark:border-gray-600 rounded-lg mb-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700"
      (click)="selectAddress(item)">
      <div class="font-medium dark:text-gray-200">
        {{ item.full_name }}
      </div>
      <div class="text-sm text-gray-600 dark:text-gray-400">
        {{ item.company_name }} {{ item.address }} {{ item.sub_district }}
        {{ item.district }} {{ item.provinces }} {{ item.zip_code }}<br />
        {{ item.email }}<br />

        <span *ngIf="item.headquarters; else branchInfo" class="font-semibold text-blue-600">
          สำนักงานใหญ่
        </span>
        <ng-template #branchInfo>
          <span class="text-gray-500">สาขา {{ item.branch }} {{ item.branch_no }}</span>
        </ng-template>
      </div>
    </div>
    <button class="mt-4 text-sm text-gray-500" (click)="showAddressModal = false">
      ปิด
    </button>
  </div>
</div>


<!-- Modal Select Vehicle -->
<div *ngIf="modalSelectVehicle" class="fixed inset-0 z-20 flex items-start justify-center bg-black bg-opacity-60 pt-10">
  <div class="bg-white dark:bg-gray-800 w-full max-w-xl p-6 rounded-lg shadow-lg relative overflow-y-auto max-h-[90vh]">
    <!-- ปุ่มปิด -->
    <button (click)="modalSelectVehicle = false"
      class="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-4xl font-bold">
      &times;
    </button>

    <h2 class="text-xl font-semibold mb-4 dark:text-gray-200">เลือกหมายเลขป้ายทะเบียน</h2>
    <!-- รายการ -->
    <ul class="max-h-64 overflow-y-auto space-y-2">
      <li *ngFor="let vehicle of licenseAll" (click)="changeLicense(vehicle.plate_number)"
        class="p-3 bg-gray-100 dark:bg-gray-700 rounded hover:bg-blue-100 dark:hover:bg-gray-600 cursor-pointer">
        <div class="font-medium dark:text-gray-200">{{ vehicle.plate_number }}</div>
        <div class="text-sm text-gray-500 dark:text-gray-400">
          {{ vehicle.vehicle_type_name }}
        </div>
      </li>
    </ul>
  </div>
</div>


<!---------------- Modal Vehicle Plate -------------------->
<div class="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50"
  *ngIf="showModalVehiclePlate">
  <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-md">
    <!---------------- Head  --------------->
    <div class="relative">
      <div class="px-4 py-6">
        <h2 class="text-lg font-bold dark:text-gray-200">กรอกป้ายหมายเลขทะเบียนรถ</h2>
      </div>
      <div class="flex justify-end absolute top-0 right-4">
        <button (click)="closeModalVehiclePlate()"
          class="text-gray-400 hover:text-gray-600 text-4xl font-bold focus:outline-none">
          &times;
        </button>
      </div>
    </div>

    <div class="border-b border-gray-300 h-[1px] w-full"></div>

    <div class="p-4">
      <!---------- ทะเบียน -------->
      <div>
        <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 font-bold">
          <span class="text-red-500">* </span>
          ทะเบียน
        </label>
        <div class="flex gap-2">
          <input [(ngModel)]="licenseTxt" id="codeInvite" type="text" maxlength="7" [disabled]="renew_"
            placeholder="กข1234"
            class="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-black dark:text-gray-200 bg-white dark:bg-gray-700 text-base shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50" />
          <!-- [disabled]="!disabled" -->
          <!-- <button
                        type="button"
                        [disabled]="!disabled"
                        class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-green-600 whitespace-nowrap transition-all duration-200 active:scale-95"
                        (click)="toggleOpenSelectVehicleProvince()"
                    >
                        {{ currentLang === "TH" ? "เลือก" : "Select" }}
                    </button> -->
        </div>
      </div>

      <!--------- จังหวัด ---------->
      <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
        <span class="text-red-500">* </span>จังหวัด
      </label>
      <div class="w-full relative">
        <input
          class="cursor-pointer bg-white dark:bg-gray-700 rounded-lg appearance-none border dark:border-gray-600 rounded w-full py-2 px-3 text-black dark:text-gray-200 text-sm leading-tight focus:outline-none focus:shadow-outline disabled:opacity-50"
          id="codeInvite" type="text" [disabled]="!disabled || renew_" placeholder="กรุณาเลือกจังหวัด"
          [(ngModel)]="provinceTxt" readonly (click)="isOpen = !isOpen" />
        <div class="relative items-center w-full">
          <div *ngIf="isOpen"
            class="absolute w-full mt-2 rounded-md shadow-lg bg-white dark:bg-gray-700 ring-1 ring-black ring-opacity-5 p-1 space-y-1 max-h-60 overflow-y-auto z-10">
            <input [(ngModel)]="searchTerm" [disabled]="!disabled"
              class="bg-white dark:bg-gray-600 border dark:border-gray-500 rounded-lg w-full py-2 px-3 text-sm focus:outline-none focus:shadow-outline dark:text-gray-200"
              type="text" placeholder="ค้นหาจังหวัด" autocomplete="off" />

            <div *ngFor="let province of filterProvinces()">
              <a (click)="selectProvince(province)"
                class="block px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 active:bg-blue-100 dark:active:bg-gray-500 cursor-pointer rounded-md">
                {{ province.value }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <!--------- ยี่ห้อ ---------->
      <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
        <span class="text-red-500">*</span>
        ยี่ห้อ
      </label>
      <select [(ngModel)]="brandTxt" [disabled]="!disabled || renew_" (change)="handleBrandChange($event)"
        class="w-full px-4 py-2 border dark:border-gray-600 rounded-lg text-base shadow bg-white dark:bg-gray-700 disabled:opacity-50"
        [ngClass]="{
            'text-gray-400 dark:text-gray-500': selectedBrand === '',
            'text-gray-700 dark:text-gray-200': selectedBrand !== ''
          }">
        <option value="" disabled selected>กรุณาเลือกยี่ห้อ</option>
        <option *ngFor="let option of BrandOptions" [value]="option.value" [disabled]="option.value === ''">
          {{ option.label }}
        </option>
      </select>

      <!--------- รุ่น ---------->
      <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
        <span class="text-red-500">*</span>
        รุ่น
      </label>

      <select [(ngModel)]="modelTxt" [disabled]="!disabled || renew_" (change)="handleModelChange($event)"
        class="w-full px-4 py-2 border dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-700 disabled:opacity-50"
        [ngClass]="{
            'text-gray-400 dark:text-gray-500': insertLicensePlate.model === '',
            'text-gray-700 dark:text-gray-200': insertLicensePlate.model !== ''
          }">
        <option value="" disabled selected>กรุณาเลือกรุ่น</option>
        <option *ngFor="let option of ModelOptions" [value]="option.value" [disabled]="option.value === ''">
          {{ option.label }}
        </option>
      </select>

      <!--------- สี ---------->
      <label class="block text-gray-700 dark:text-gray-300 text-base mb-2 mt-4 font-bold">
        <span class="text-red-500">*</span>
        สี
      </label>
      <select [(ngModel)]="colorTxt" (change)="handleColorChange($event)"
        class="w-full px-4 py-2 border dark:border-gray-600 rounded-lg text-base shadow bg-white dark:bg-gray-700"
        [ngClass]="{
            'text-gray-400 dark:text-gray-500': colorTxt === '',
            'text-gray-700 dark:text-gray-200': colorTxt !== ''
          }">
        <option value="" disabled selected>กรุณาเลือกสี</option>
        <option *ngFor="let option of ColorOptions" [value]="option.value" [disabled]="option.value === ''">
          {{ option.label }}
        </option>
      </select>

      <!--------- ปุ่ม ---------->
      <button class="w-full bg-green-500 text-white rounded-md p-2 mt-4 transition-colors"
        (click)="submitModalVehiclePlate()" type="submit">
        ยืนยัน
      </button>
    </div>
  </div>
</div>


<!---------------- MODAL TAX ------------------------>
<div *ngIf="showTaxModal" class="fixed inset-0 z-10 flex items-start justify-center bg-black/50 pt-3 px-4">
  <div
    class="bg-white dark:bg-gray-800 rounded-xl p-6 w-full max-w-4xl max-h-[90vh] shadow-lg relative overflow-y-auto max-h-screen">
    <button (click)="closeTaxModal()" class="absolute top-4 right-4 text-gray-400 hover:text-red-500 text-2xl">
      <i class="fas fa-times"></i>
    </button>

    <h2 class="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-6 text-center">
      ขอใบกำกับภาษีแบบเต็มรูป
    </h2>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm text-gray-700 dark:text-gray-300">
      <!-- ประเภท -->
      <div class="col-span-full">
        <label class="block font-medium text-base">ประเภท</label>
        <select
          class="w-full px-4 py-2 border dark:border-gray-600 rounded-lg shadow bg-white dark:bg-gray-700 dark:text-gray-200"
          [(ngModel)]="selectedTaxType" (ngModelChange)="filterAddressByTaxType()">
          <option value="1">บุคคลธรรมดา</option>
          <option value="2">นิติบุคคล</option>
        </select>
      </div>

      <!-- เลือกที่อยู่ -->
      <div class="col-span-full" *ngIf="showSelectAddress">
        <div
          class="w-full p-4 border dark:border-gray-600 rounded-xl shadow-sm bg-white dark:bg-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 transition flex justify-between items-start"
          (click)="openAddressModal()">
          <div class="flex items-start gap-3">
            <span class="text-orange-500 text-xl mt-1">📍</span>
            <div class="flex flex-col">
              <div class="font-semibold text-base dark:text-gray-200">
                {{ selectedAddress?.full_name }}
                <span class="text-sm text-gray-400 ml-2">
                  {{ selectedAddress?.phone }}
                </span>
              </div>
              <div class="text-sm mt-1 leading-snug text-gray-700 dark:text-gray-300">
                {{ selectedAddress?.company_name }}
                {{ selectedAddress?.address }}
                {{ selectedAddress?.sub_district }}
                {{ selectedAddress?.district }}
                {{ selectedAddress?.provinces }}
                {{ selectedAddress?.zip_code }}
              </div>
            </div>
          </div>
          <i class="fas fa-chevron-right text-gray-400 mt-1"></i>
        </div>
      </div>
      <!-- ภาษี/ที่อยู่ -->
      <div class="sm:col-span-2">
        <label>เลขประจำตัวผู้เสียภาษี</label>
        <div class="flex gap-2">
          <input [(ngModel)]="taxId" type="text"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200" />
          <button *ngIf="selectedTaxType === '2'" type="button"
            class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-green-600 whitespace-nowrap"
            (click)="getAddressByTaxId()">
            ค้นหา
          </button>
        </div>
      </div>
      <!-- สำนักงานใหญ่ toggle -->
      <div *ngIf="selectedTaxType === '2'"
        class="flex items-center justify-between col-span-full border-b dark:border-gray-600 py-2">
        <span class="text-base">สำนักงานใหญ่</span>
        <label class="flex items-center gap-2 cursor-pointer text-gray-800 dark:text-gray-200">
          <input type="checkbox" class="w-5 h-5 text-green-600 accent-green-600 focus:ring-green-500 rounded"
            [(ngModel)]="mainOffice" />
          สำนักงานใหญ่
        </label>
      </div>

      <!-- ข้อมูลทั่วไป -->
      <div>
        <label>ชื่อบริษัท / ผู้เสียภาษี</label>
        <input [(ngModel)]="taxName" type="text"
          class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200" />
      </div>

      <div>
        <label>เบอร์โทรศัพท์</label>
        <input [(ngModel)]="tax_phone" maxlength="10" type="text"
          class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200" />
      </div>

      <div class="sm:col-span-2">
        <label>อีเมล</label>
        <input [(ngModel)]="email" type="text"
          class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200" />
      </div>

      <!-- ชื่อสาขา -->
      <div *ngIf="!mainOffice && selectedTaxType === '2'">
        <label>ชื่อสาขา</label>
        <input [(ngModel)]="branchName" type="text"
          class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200" />
      </div>

      <div *ngIf="!mainOffice && selectedTaxType === '2'">
        <label>รหัสประจำสาขา</label>
        <input [(ngModel)]="branchNo" type="text"
          class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200" />
      </div>

      <div class="sm:col-span-2">
        <label>ที่อยู่</label>
        <input [(ngModel)]="address" type="text"
          class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200" />
      </div>

      <!-- จังหวัด -->
      <div>
        <label>จังหวัด</label>
        <select [(ngModel)]="selectedProvinceId" (change)="onProvinceChange()"
          class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200">
          <option [value]="null" disabled selected>เลือกจังหวัด</option>
          <option *ngFor="let province of provincess" [value]="province.id">
            {{ province.name_th }}
          </option>
        </select>
      </div>

      <!-- อำเภอ -->
      <div>
        <label>อำเภอ</label>
        <select [(ngModel)]="selectedAmphureId" (change)="onAmphureChange()" class="w-full border px-3 py-2 rounded-md">
          <option [value]="null" disabled selected>เลือกอำเภอ</option>
          <option *ngFor="let amphure of filteredAmphures" [value]="amphure.id">
            {{ amphure.name_th }}
          </option>
        </select>
      </div>

      <!-- ตำบล -->
      <div>
        <label>ตำบล</label>
        <select [(ngModel)]="selectedTambonId" (change)="onTambonsChange()" class="w-full border px-3 py-2 rounded-md">
          <option [value]="null" disabled selected>เลือกตำบล</option>
          <option *ngFor="let tambon of filteredTambons" [value]="tambon.id">
            {{ tambon.name_th }}
          </option>
        </select>
      </div>

      <!-- รหัสไปรษณีย์ -->
      <div>
        <label>เลขไปรษณีย์</label>
        <input type="text" [(ngModel)]="zipcode" readonly class="w-full border px-3 py-2 rounded-md" />
      </div>
    </div>

    <div class="mt-6 text-center">
      <button class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition" (click)="summit()">
        บันทึก
      </button>
    </div>
  </div>
</div>